export const chemistryTestScore = [
    {
        number: 1,
        items: [
            {
                name: 'Part One',
                progress: 54,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            },
            {
                name: 'Part One',
                progress: 79,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            }]
    },
    {
        number: 2,
        items: [
            {
                name: 'Part One',
                progress: 54,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            },
            {
                name: 'Part One',
                progress: 79,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            }]
    },
    {
        number: 3,
        items: [
            {
                name: 'Part One',
                progress: 54,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            },
            {
                name: 'Part One',
                progress: 79,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            }]
    },
    {
        number: 4,
        items: [
            {
                name: 'Part One',
                progress: 54,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            },
            {
                name: 'Part One',
                progress: 79,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            }]
    },
    {
        number: 5,
        items: [
            {
                name: 'Part One',
                progress: 54,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            },
            {
                name: 'Part One',
                progress: 79,
                video_time: '12',
                recent_quiz_score: '90',
                discussion: '4',
                challenges: '34',
                concepts_wrong: '12',
                recent_quiz_time: '6',
                merits_earned: '12',
                challenge_lost: '15'
            }]
    }
];



// WEBPACK FOOTER //
// ./src/data/chemistryTestScore.js